import React from 'react';
import useCurrentUser from '../../hooks/useCurrentUser';
import SavingIndicator from '../Utils/SavingIndicator';
import AuthorEditToggle from '../v2/Nav/AuthorEditToggle';
import AuthorViewLearning3kLesson from '../v2/Nav/AuthorViewLearning3kLesson';
import AuthorViewLearning3kGradedQuiz from '../v2/Nav/AuthorViewLearning3kGradedQuiz';
import useCurrentComponent from '../../hooks/useCurrentComponent';

export default function EditBar() {
  const { canAuthor } = useCurrentUser();
  const { lessonId } = useCurrentComponent();
  const { gradedQuizId } = useCurrentComponent();

  if (!canAuthor) return null;

  return (
    <div className="header-bar__edit">
      <div className="header-bar__edit-wrapper">
        <div className="header-bar__edit-notification">
          <SavingIndicator />
        </div>
        <AuthorEditToggle className="header-bar__edit-title" />
        {lessonId && <AuthorViewLearning3kLesson lessonId={lessonId} />}
        {gradedQuizId && <AuthorViewLearning3kGradedQuiz gradedQuizId={gradedQuizId} />}
      </div>
    </div>
  );
}
